import React, { useEffect, useState } from 'react';

import './Tooltip.wrapper.scss';

function TooltipWrapper({children, label, value, fontSize, isBelow}){
    const tipRef = React.createRef();
    const [left, setLeft] = useState(0);
    const [top, setTop] = useState(0);
    useEffect(() => {
        const bounding = tipRef.current.getBoundingClientRect();
        setLeft(bounding.width / 2);
        setTop(top => !top ? (!!isBelow ? bounding.height + 10 : -bounding.height) : top);
    }, [tipRef, isBelow])
    return (
        <div className="_tooltipWrapper">
            <div className={`_tooltip ${isBelow ? 'below' : ''}`} ref={tipRef} style={{transform: `translate(${-left}px, ${top}px)`}}>
                <p className={`_label ${!value ? 'centered' : ''}`}>{label}</p>
                {
                    value?
                    <p className="_value" style={{fontSize: fontSize? fontSize : '.85em'}}>{value}</p>
                    : ''
                }
                <div className="arrowDown"></div>
            </div>
            {children}
        </div>
    )
}

export default TooltipWrapper;